import { Component, OnDestroy, OnInit } from '@angular/core';
import { PaymentPaymentOptionCardFormAbstractForm } from '../payment.payment.option.card.form.abstract-form';
import { PaymentStepsService } from '../../../../../../services/payment-steps.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { PaymentService } from '../../../../../../services/payment.service';
declare var Mercadopago: any;
declare interface IdentificationType {
    id: string;
    max_length: number;
    min_length: number;
    name: string;
    type: string;
}

@AutoUnsubscribe()
@Component({
    'selector': 'payment-payment-option-card-form-mercado-pago',
    'templateUrl': './payment.payment.option.card.form.mercado-pago.component.html'
})
export class PaymentPaymentOptionCardFormMercadoPagoComponent extends
    PaymentPaymentOptionCardFormAbstractForm implements OnInit, OnDestroy {
    private payloadControl: FormControl;
    private payloadControlAdded = false;

    public paymentMethodId;
    public identificationForm = new FormGroup({});
    public identificationTypeControl = new FormControl('', [Validators.required]);
    public identificationTypes: Array<IdentificationType> = [];

    paymentRefused: Subscription;

    constructor(private paymentService: PaymentService, 
                protected paymentStepsService: PaymentStepsService
    ) {

        super();

        this.paymentRefused = this.paymentService.refused$.subscribe(() => {
            this.paymentStepsService.loadPaymentMethods().subscribe();
        });
    }

    ngOnInit() {
        this.identificationForm.setControl('type', this.identificationTypeControl);

        this.payloadControl = new FormControl('', [Validators.required]);
    }
    ngOnDestroy() {
        if (this.payloadControlAdded) {
            this.form.removeControl('payload');
            this.payloadControlAdded = false;

            this.clearIdentificationTypesControls();
            this.identificationTypes = [];
        }
    }
    public scriptLoaded() {
        Mercadopago.setPublishableKey(this.paymentGateway.publishable_key);
        Mercadopago.getIdentificationTypes((status, response: Array<IdentificationType>|any) => {
            if (response.error) {
                this.pending.emit();
                return ;
            }

            this.identificationTypes = response;
            this.identificationTypeControl.setValue(this.identificationTypes[0].id);
            this.createIdentificationTypeControl();
        });
    }
    public buildPayload() {
        if (this.form.valid && this.identificationForm.valid) {
            this.payloadControl.setValue({});

            this.form.addControl('payload', this.payloadControl);
            this.payloadControlAdded = true;

            this.createPaymentMethodId();
        } else {
            this.pending.emit();
        }
    }
    public buildDocumentTypeControl() {
        this.clearIdentificationTypesControls();
        this.createIdentificationTypeControl();
        this.buildPayload();
    }

    private clearIdentificationTypesControls() {
        this.identificationTypes.forEach(
            (type: IdentificationType) => this.identificationForm.removeControl(type.id)
        );
    }
    private createIdentificationTypeControl() {
        const selectedType = this.identificationForm.controls['type'].value;
        const identificationType = this.identificationTypes.find(type => type.id === selectedType);
        const control = new FormControl('', [
            Validators.minLength(identificationType.min_length),
            Validators.maxLength(identificationType.max_length)
        ]);
        this.identificationForm.setControl(identificationType.id, control);
    }
    private createPaymentMethodId() {
        const number = this.form.controls.number.value.replace(/\s/g, '');
        const bin = number.substr(0, 6);

        Mercadopago.getPaymentMethod({
            'bin': bin
        }, (status, response: any) => {
            if (response.error) {
                console.warn('[MercadoPago] getPaymentMethod -> ' + response.message);
                this.pending.emit();
                return ;
            }
            if (response.length === 0 || response[0] === undefined || response[0].id === undefined) {
                console.warn('[MercadoPago] Unexpected MercadoPago response -> ', response);
                this.pending.emit();
                return ;
            }

            this.paymentMethodId = response[0].id;
            this.setToPayload('paymentMethodId', this.paymentMethodId);
            this.createToken();
        });
    }
    private createToken() {
        const $form = document.getElementById(`card-${this.index}-${this.cardIndex}`);
        Mercadopago.createToken($form, (status, response: any) => {
            if (response.error) {
                console.warn('[MercadoPago] createToken -> ' + response.message);
                this.pending.emit();
                return ;
            }

            this.setToPayload('token', response.id);
            this.ready.emit();
        });
    }
    private setToPayload(key: string, value: any) {
        const payload = this.payloadControl.value || {};
        payload[key] = value;

        this.payloadControl.setValue(payload);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/payment/payment/option/card/option/form/mercado-pago/payment.payment.option.card.form.mercado-pago.component.ts